<div class="card card-default">

    <div class="panel-body panel-body-padding">
        
        <span *ngIf="data&&!data.projectScenario.deletedDate" class="float-end" style="color:darkgrey">Scenario
            '{{data.projectScenario.exportedScenarioName}}' was exported by {{data.projectScenario.exportedByUser}} on
            {{data.projectScenario.exportedDate | date:'dd/MM/yyyy'}}</span>
        <span *ngIf="data&&data.projectScenario.deletedDate" class="float-end" style="color:#a94442">Scenario
            '{{data.projectScenario.exportedScenarioName}}' was deleted by {{data.projectScenario.deletedByUser}} on
            {{data.projectScenario.deletedDate | date:'dd/MM/yyyy'}}</span><br />
        <div class="box-container" style="background-color: #fafafa;">
            <form name="guardedForm" [formGroup]="modalForm" novalidate autocomplete="off">
                <div>
                    <div class="card-caption float-start" *ngIf="data&&data.noteId != 0">
                        <a uib-tooltip="Return to Scenario Summary"
                            (click)="showProjectSummary()">{{data.audit.auditNote | elipsis: 50}} (Ref:
                            N{{('00000' + data.noteId).slice(-6)}})</a>
                    </div>
                    
                    <button permission="modify-notes" uib-tooltip="Save Note" class="btn btn-sm sk-btn-primary float-end" style="margin-bottom: 10px; margin-right:0px"
                        (click)="saveNote()" [disabled]="inputNote.errors||!modified"
                        *ngIf="data&&!data.deleted && !data.projectScenario.deletedDate">Save</button>
                    
                    <button permission="modify-notes" uib-tooltip="Modify Note" class="btn btn-sm sk-btn-light float-end" style="margin-bottom: 10px;" (click)="modify = !modify;detectChange()"
                        *ngIf="data&&!data.projectScenario.deletedDate && !data.deleted">Modify</button>
                    <button permission="delete-notes" uib-tooltip="Delete Note" class="btn btn-sm sk-btn-light float-end" style="margin-bottom: 10px;"
                        (click)="deleteNote()"
                        *ngIf="data&&data.noteId != 0 && !data.deleted && !data.projectScenario.deletedDate"
                        confirm>Delete</button>
                    <button uib-tooltip="Return to Scenario Summary" class="btn btn-sm sk-btn-light float-end" style="margin-bottom: 10px;"
                        (click)="showProjectSummary()">Scenario Summary</button>
                    
                </div>
                
                <div *ngIf="modify">
                    <br />
                
                    <textarea *ngIf="data&&!data.deleted" formControlName="inputNote" style="resize: none;" rows="16" class="form-control" (input)="modified=true"
                        name="inputNote" placeholder="Note (max 2000 characters)" [(ngModel)]="data.audit.auditNote"
                        ng-maxlength="2000" ng-minlength="3" required></textarea>
                    <div class="sk-red">
                        <span *ngIf="inputNote.errors?.['required']">A note is required.</span>
                        <span *ngIf="inputNote.errors?.['minlength']">The note must be at least 3
                            characters.</span>
                        <span *ngIf="inputNote.errors?.['maxlength']">The note must be 2000 characters or
                            less.</span>
                    </div>
                </div>
                
                <br *ngIf="!modify&&history[0]">
                <br *ngIf="!modify&&history[0]">
                <div class="box" style="margin-left:13px" *ngIf="!modify&&history[0]" [innerHtml]="lines(history[0].auditNote)"></div>
                <app-location-file [owner]="data" [modify]="modify" (filesChanged)="modified=true"></app-location-file>
                <br />
                <p *ngIf="history[0]">
                    <i>{{history[0].auditUser.name}} {{history[0].auditSummary}} on {{history[0].auditDate |
                        date:'dd/MM/yyyy'}} at {{history[0].auditDate | date:'hh:mm a'}}</i>
                </p>
                <p *ngIf="history[0]">
                    <i class="bi bi-envelope"></i>&nbsp; <a
                        href="mailto:{{history[0].auditUser.email}}">{{history[0].auditUser.email}}</a>&nbsp;&nbsp;&nbsp;
                    <i class="bi bi-telephone"> {{history[0].auditUser.contactNumber}}&nbsp;&nbsp;&nbsp;</i>
                    <span class="float-end">
                        <a (click)="isHistoryCollapsed=!isHistoryCollapsed"><small *ngIf="!isHistoryCollapsed" class="showHide">hide
                                history</small><small *ngIf="isHistoryCollapsed" class="showHide">show history</small></a>
                
                    </span>
                </p>

            </form>
        </div>
        <div style="max-height: 1000px;overflow: auto;">

            <div class="timeline" *ngIf="!isHistoryCollapsed">

                <div class="entry" *ngFor="let item of history">

                    <div class="title">
                        <h3>{{item.auditDate | date:'EEEE'}}</h3>
                        <p>{{item.auditDate | date:'MMMM d, y'}}</p>
                        <p>{{item.auditDate | date:'h:mm a'}}</p>
                        <p>{{item.auditUser.name}}</p>
                    </div>

                    <div class="body">
                        
                        <div class="sb" [ngClass]="{'sb-deleted': data&&data.deleted }">
                            <h3 [innerHtml]="lines(item.auditNote)"></h3>
                            <p>
                                <i>{{item.auditUser.name}} {{item.auditSummary}} on {{item.auditDate |
                                    date:'dd/MM/yyyy'}} at {{item.auditDate | date:'hh:mm a'}}</i>
                            </p>
                            <p>
                                <i class="far fa-envelope"></i> <a
                                    href="mailto:{{item.auditUser.email}}">{{item.auditUser.email}}</a>&nbsp;&nbsp;&nbsp;
                                <i class="fas fa-phone"> {{item.auditUser.contactNumber}}&nbsp;&nbsp;&nbsp;</i>
                            </p>
                            <strong *ngIf="data&&data.deleted" style="color: #a94442">Note Deleted</strong>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>